import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { displayMessages } from './common';

export function buscarDocumento() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const tipo = getState().busquedadocumento.get('tipo')
        const busqueda = getState().busquedadocumento.get('busqueda')

        axios.get(`${API_URL}/documentos/busqueda`, { params: { busqueda, tipo }})
		.then((res) => {
			const fn1 = d => d({ type: types.BUSQUEDADOCUMENTO_OBTENER_DOCUMENTOS, payload: { data: res.data } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
    }
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.BUSQUEDADOCUMENTO_MODIFICAR_INPUTS, payload: { path, value } })
	}
}

export function reiniciarEstado() {
	return (dispatch) => {
		dispatch({ type: types.BUSQUEDADOCUMENTO_REINICIAR_ESTADO })
	}
}


// WEBPACK FOOTER //
// ./src/actions/busquedadocumento.js